import { StrictMode } from "react";
import { MsalProvider } from "@azure/msal-react";
import "cenero-ui-library/dist/style.css";
import "@/assets/css/global.css";
import App from "@/App.js";
import { msalInstance } from "@/lib/msal-config";
import { createRoot } from "react-dom/client";

// ---------------------- Root

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  </StrictMode>,
);
